import React from 'react';
import Title from '@/components/Title';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import LeadButton from '@/components/LeadButton';

export interface TeachersConfig {
  img: string;
  name: string;
  school: string;
  title: string;
  alt: string;
  id: string | number;
}

export interface QualificationConfig {
  data: string;
  dataDescription: string;
  id: string | number;
}

interface IProps {
  teachersConfig?: TeachersConfig[];
  qualificationConfig?: QualificationConfig[];
  title?: string;
  subTitle?: string;
}

const Teachers = ({
  teachersConfig: teachersConfigProps,
  qualificationConfig: qualificationConfigProps,
  title,
  subTitle,
}: IProps) => {
  const { t } = useTranslation(['home', 'english']);
  const teachersConfig: TeachersConfig[] = teachersConfigProps || [
    {
      img: '/images/english/teachers-3.png',
      name: t('english:师资力量-姓名-3'),
      school: t('english:师资力量-学校-3'),
      title: t('english:师资力量-介绍-3'),
      alt: t('english:师资力量-3-alt'),
      id: 2,
    },

    {
      img: '/images/english/teachers-2.png',
      name: t('english:师资力量-姓名-2'),
      school: t('english:师资力量-学校-2'),
      title: t('english:师资力量-介绍-2'),
      alt: t('english:师资力量-2-alt'),
      id: 1,
    },
    {
      img: '/images/english/teachers-1.png',
      name: t('english:师资力量-姓名-1'),
      school: t('english:师资力量-学校-1'),
      title: t('english:师资力量-介绍-1'),
      alt: t('english:师资力量-1-alt'),
      id: 0,
    },
  ];
  const qualificationConfig: QualificationConfig[] = qualificationConfigProps || [
    {
      data: '1%',
      dataDescription: 'english:简历通过率',
      id: 1,
    },
    {
      data: '100%',
      dataDescription: 'english:学士学位',
      id: 2,
    },
    {
      data: '83%',
      dataDescription: 'english:硕士及以上学位',
      id: 3,
    },
    {
      data: 'english:平均教学经验-经验',
      dataDescription: 'english:平均教学经验',
      id: 4,
    },
  ];
  return (
    <section className="relative mt-[5rem] text-center lg:mt-[140px] xl:mt-[200px]">
      <div className="container">
        <Title innerHTML theme="english">
          {title || t('english:名师亲授')}
        </Title>
        <p className="mx-auto mt-[24px] text-center text-base font-normal !leading-normal text-wk-words-1 lg:text-base xl:w-[1100px] xl:text-[20px]">
          {subTitle || t('english:悟空ELA')}
        </p>
      </div>

      <div className="relative z-10">
        <div className="container">
          {/* 资格 */}
          <ul className=" mt-6 grid grid-cols-2 gap-4 lg:mt-12 lg:grid-cols-4 lg:gap-5 xl:gap-10">
            {qualificationConfig.map((item) => (
              <li
                key={item.id}
                className="  relative rounded-3xl border-2 border-white bg-[linear-gradient(184deg,rgba(135,67,249,0.03)_11.7%,rgba(196,65,234,0.03)_90.39%),linear-gradient(180deg,rgba(255,255,255,0.40)_0%,rgba(255,255,255,0.90)_100%)] px-3 py-2.5 shadow-wk1 backdrop-blur-md  lg:px-8 lg:py-6 xl:rounded-5xl"
              >
                <p className="text-[1.75rem] font-black  text-wk-words-1 xl:text-[34px]">{t(item.data)}</p>
                <p className="mt-2 text-sm text-wk-words-5 lg:text-base xl:text-xl">{t(item.dataDescription)}</p>
              </li>
            ))}
          </ul>
          {/* 老师 1920 显示 */}
          <div className="hidden xl:block">
            <ul className="mt-[80px] flex justify-center space-x-6">
              {teachersConfig.map((item) => (
                <li key={item.id} className="">
                  <div className="linearGradientEnglishTeahcerCardBg relative  h-[240px] w-[452px] rounded-5xl border-2 border-white shadow-wk2 ">
                    <div className="flex h-full bg-[url('/images/english/teachers-head-bg.png')]   bg-[length:239px_279px] bg-left-top bg-no-repeat">
                      {/* 老师图片 */}
                      <div className="relative  w-[190px]">
                        <Image
                          className="absolute bottom-0 left-0 h-[212px] w-[182px]"
                          alt={t('english:seo-悟空高级英文阅读与写作老师')}
                          width={190}
                          height={255}
                          src={item.img}
                        />
                      </div>
                      {/* 信息 */}
                      <div className=" flex-1 py-6 pl-1 pr-5 text-left xl:pt-[44px]">
                        <h3 className="text-[28px]/normal font-semibold">{t(item?.name)}</h3>
                        <h3 className=" mt-[4px] text-base/normal text-wk-words-5">{t(item?.school)}</h3>
                        <h4
                          className="line-clamp-6 text-sm leading-[22px] xl:mt-[20px] xl:text-[16px] [&_p]:mb-[8px] [&_p]:flex [&_p]:items-start [&_p]:text-wk-words-1 [&_p_span]:mr-[8px]"
                          dangerouslySetInnerHTML={{ __html: t(item?.title) }}
                        />
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
        {/* 移动端老师样式 */}
        <div className="mt-6 overflow-hidden lg:mt-20 lg:overflow-visible xl:hidden">
          <ul className="hideScrollbar flex flex-row items-stretch space-x-5 overflow-x-scroll px-5 pb-6 lg:justify-center lg:space-x-4 lg:overflow-visible lg:px-0 lg:pb-0">
            {teachersConfig.map((item) => (
              <li className="lg:[317px] flex w-[280px] shrink-0 flex-col " key={item.id}>
                <div className="linearGradientEnglishTeahcerCardBg  relative h-[170px] w-full rounded-3xl border-2 border-white shadow-wk2 xl:h-[200px] ">
                  <div className="flex h-full bg-[url('/images/home/teachers-head-bg.png')]   bg-[length:180px_209px]  bg-[-4px_10px] bg-no-repeat">
                    {/* 老师图片 */}
                    <div className="relative w-[125px]">
                      <Image
                        className="absolute bottom-0 left-0 h-[146px] w-[125px] "
                        alt={t('english:seo-悟空高级英文阅读与写作老师')}
                        width={125}
                        height={146}
                        src={item.img}
                      />
                    </div>
                    {/* 信息 */}
                    <div className="flex-1 pl-1 pr-5 pt-[24px] text-left lg:pt-[44px]">
                      <h3 className="text-xl  font-semibold">{t(item?.name)}</h3>
                      <h3 className=" mt-1 text-sm text-wk-words-5">{t(item?.school)}</h3>
                    </div>
                  </div>
                </div>
                <div className=" relative z-10 mt-[-30px] flex w-full flex-1 flex-col justify-between rounded-3xl bg-white p-5 shadow-wk1">
                  <h4
                    className="xl:mt-[20px] xl:text-[16px] [&_p:last-child]:mb-0 [&_p]:mb-[8px] [&_p]:flex [&_p]:items-start [&_p]:text-left [&_p]:text-sm [&_p]:leading-normal [&_p]:text-wk-words-1 [&_p]:xl:leading-6 [&_p_span]:mr-[8px]"
                    dangerouslySetInnerHTML={{ __html: t(item?.title) }}
                  />
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <LeadButton
            subject="english"
            theme="english"
            size="xl"
            className=" lg:mt-[48px] xl:mt-[60px]"
            traceName="O_EnglishCourse_TeacherIntroduction_CTAClick"
            traceGa4Name="new_entry_EnglishCourse_TeacherIntroductionCTA"
          >
            {t('english:立即体验')}
          </LeadButton>
        </div>
      </div>
    </section>
  );
};

export default Teachers;
